import Container from '@/components/@base/container';
import XImage from '@/components/@base/x-image';

import DateCard from './dateCard';
import Description from './description';
import Note from './note';
import { HistoryInfoData } from '../../services';
import { historyYears } from '../../services/type';

type HistoryInfoProps = {
  currentSlide: number | number[];
};
export default function HistoryInfo({ currentSlide }: HistoryInfoProps) {
  const data =
    typeof currentSlide === 'number' &&
    HistoryInfoData[
      currentSlide >= historyYears[1403]
        ? historyYears[1403]
        : currentSlide < historyYears[1393]
          ? historyYears[1393]
          : currentSlide
    ];

  if (!data) {
    return null;
  }

  return (
    <Container className='grid gap-4 md:mt-10 md:grid-cols-2'>
      <Container className='flex flex-col gap-8'>
        <DateCard day={data.day} month={data.month} />
        <Description description={data.description} />
        <Note note={data.note} />
      </Container>
      <Container className='relative flex items-start justify-end'>
        <XImage
          src={data.image}
          alt='home screen'
          className='rounded-xl border-[3px] border-[#FFFFFF] shadow-[0px_20px_60px_-15px_#00000026]'
          width={352}
          height={384}
        />
      </Container>
    </Container>
  );
}
